// extracted by mini-css-extract-plugin
export var content = "_pd-1";
export var noScroll = "_pd-3";
export var paper = "_pd-0";
export var scrollable = "_pd-2";